import styled from 'styled-components';


export const Wrapper = styled.div`
  background: #1C1c1c;
`;